var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 59,
    height: 59,
    rx: 11.5,
    fill: "url(#paint0_linear_1048_4471)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 59,
    height: 59,
    rx: 11.5,
    stroke: "url(#paint1_linear_1048_4471)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7375 35.3375L33.9375 18.0125C33.0375 16.6625 31.575 15.875 30 15.875C28.425 15.875 26.9625 16.6625 26.0625 18.0125L15.2625 35.3375C14.025 37.3625 13.9125 39.725 15.0375 41.75C16.1625 43.775 18.3 45.0125 20.6625 45.0125H39.3375C41.7 45.0125 43.8375 43.775 44.9625 41.75C46.0875 39.725 45.975 37.3625 44.7375 35.3375ZM27.6375 24.7625C28.7625 23.4125 31.125 23.4125 32.25 24.7625C32.8125 25.4375 33.15 26.3375 32.925 27.2375L32.1375 32.8625C32.025 33.425 31.575 33.875 31.0125 33.875H28.7625C28.2 33.875 27.75 33.425 27.6375 32.8625L26.85 27.2375C26.85 26.3375 27.075 25.4375 27.6375 24.7625ZM30.5625 40.625H29.4375C27.8625 40.625 26.625 39.3875 26.625 37.8125C26.625 36.2375 27.8625 35 29.4375 35H30.5625C32.1375 35 33.375 36.2375 33.375 37.8125C33.375 39.3875 32.1375 40.625 30.5625 40.625Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1048_4471",
    x1: 30,
    y1: 0.5,
    x2: 30,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA1010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1048_4471",
    x1: 30,
    y1: 0.5,
    x2: 30,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.4034e009134a15d954f9e0ab62e8f712.svg";
export { ForwardRef as ReactComponent };